import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';

const mainTheme = responsiveFontSizes(
  createMuiTheme({
    typography: {
      fontFamily: 'Montserrat, sans-serif',
      h1: {
        fontFamily: 'Courgette, cursive',
      },
      h2: {
        fontFamily: 'Courgette, cursive',
      },
      h3: {
        fontFamily: 'Courgette, cursive',
      },
    },
  }),
);

export default mainTheme;